import Component from '../core/Component.js'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export const defaults = {
    cellSelector: '[data-ref="ProductListSlider:item"]',
    prevNextButtons: false,
    pageDots: false,
    contain: true,
    autoplay: false,
    lazyLoad: true,
    responzive: true,
    resize: true,
    percentPosition: true,
    adaptiveHeight: false
}

export const STATUS = {
    READY: 'is-ready',
    DISABLED: 'is-disabled'
}

export default class ProductListSlider extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }

        let options = {}

        if (this.element.dataset.options) {
            options = JSON.parse(this.element.dataset.options || '') || {}
        }

        this.options = {
            ...defaults,
            ...options,
        }

        this.flickity = null

        this.enquireHandler = {
            match: ::this.match,
            unmatch: ::this.unmatch
        }
    }

    prepare() {
        if (this.ref.items.length > 1) {
            enquire.register(queries.mediumMax, this.enquireHandler)
        }
    }

    destroy() {
        enquire.unregister(queries.mediumMax, this.enquireHandler)
    }

    match() {
        if (this.ref.items.length > 1) {
            this.element.classList.add(STATUS.READY)
            this.flickity = new Flickity(this.element, this.options)

            this.flickity.on('change', this.handleFlickityChange)

            setTimeout(() => {
                this.flickity.resize()
            }, 100)
        }
    }

    unmatch() {
        this.element.classList.remove(STATUS.READY)
        if (this.flickity) {
            this.flickity.destroy()
            this.flickity = null
        }
    }

    handleFlickityChange = () => {
        this.clearAriaHidden()
    }

    clearAriaHidden() {
        this.flickity.cells.forEach(cell => cell.element.removeAttribute('aria-hidden'))
    }
}